import React, { useState, useRef } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextField,
  Button,
} from '@mui/material';
// Components
// API
import { postDeliveryImport } from '../../../api/productSamplingWorkflowApi';

export default function ImportModal({ id, importModal, setImportModal, handleViewPlan }) {
  const importRequestDefault = {
    file: null,
  };

  const fileInputRef = useRef(null);
  const [importRequest, setImportRequest] = useState(importRequestDefault);
  const [importDetails, setImportDetails] = useState({});

  const handleCancel = () => {
    setImportModal({ ...importModal, toggle: false });
  };

  const handleChange = (e) => {
    setImportRequest({ ...importRequest, file: e.target.files[0] });
  };

  const handleSubmitImport = async () => {
    const toastId = toast.loading('Processing request please wait...');

    try {
      const request = {
        plan_id: id,
        file: importRequest?.file,
      };

      const response = await postDeliveryImport(request);
      const { code, message, data } = response.data;

      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setImportRequest(importRequestDefault);

      if (code !== '200') {
        let messages = [];
        if (Array.isArray(data)) {
          messages = data.map((item) => `${item.column}`);
        } else if (data && typeof data === 'object') {
          messages = Object.entries(data).flatMap(([field, errors]) =>
            Array.isArray(errors) ? errors : [errors],
          );
        } else {
          messages = [message || 'Something went wrong.'];
        }
        Swal.fire({
          icon: 'error',
          title: 'Import Failed',
          width: 700,
          html: `
              <div style="text-align: left;">
                ${messages
                  .map(
                    (message) => `
                      <div style="
                        margin-bottom: 8px;
                        padding: 10px;
                        border: 1px solid #ddd;
                        border-radius: 6px;
                      ">
                        ${message}
                      </div>
                    `,
                  )
                  .join('')}
              </div>
            `,
        });
        throw new Error('Failed to import delivery status.');
      }
      toast.dismiss();
      toast.success(message, { id: toastId });
      setImportDetails(data);
      handleViewPlan();
    } catch (error) {
      toast.dismiss();
      toast.error(error?.message || 'Failed to import delivery status.', { id: toastId });
    }
  };

  return (
    <div>
      <Dialog open={importModal?.toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
        <DialogTitle>Product Sample Status Import</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid xs={12} md={12} lg={12} sx={{ padding: 2 }}>
              <Box sx={{ fontWeight: 'bold', color: 'red' }}>
                {' '}
                Updated: {importDetails?.updated ?? 0} Created: {importDetails?.created ?? 0}{' '}
                Notified: {importDetails?.notified ?? 0}
              </Box>
            </Grid>

            <Grid xs={12} md={12} lg={12}>
              <Box component='form' noValidate autoComplete='off'>
                <TextField
                  type='file'
                  id='file'
                  name='file'
                  onChange={(e) => handleChange(e)}
                  size='small'
                  fullWidth
                  style={{ marginTop: '10px' }}
                  inputRef={fileInputRef}
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='success' onClick={handleSubmitImport}>
            Import
          </Button>
          <Button variant='contained' color='error' onClick={handleCancel}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ImportModal.propTypes = {
  id: PropTypes.string,
  importModal: PropTypes.shape({
    toggle: PropTypes.bool,
  }),
  setImportModal: PropTypes.func,
  handleViewPlan: PropTypes.func,
};
